/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/prop-types */
import {
  UilEstate,
  UilMap,
  UilMapPinAlt,
  UilWindsock
} from '@iconscout/react-unicons';
import classNames from 'classnames';
import { Card } from 'react-bootstrap';
import EmployeeInfoItem from './EmployeeInfoItem';

const EmployeeAddressCard = ({ className, data }) => {
  const { current_address } = data?.personal_information || {};
  return (
    <Card className={classNames(className)}>
      <Card.Body>
        <div className="d-flex align-items-center justify-content-between mb-5">
          <h3>Address</h3>
        </div>
        <EmployeeInfoItem
          className="mb-4"
          label="Home"
          icon={UilEstate}
          value={current_address || '--'}
        />
      </Card.Body>
    </Card>
  );
};

export default EmployeeAddressCard;
